import { mockInviteA } from './mockInviteA'
import { MOCK_INVITE_A_ID } from './mockInvitesConstants'
import { InvitesReducer } from 'state/reducers/types/InvitesReducer'

export const mockInvites: InvitesReducer = {
  [MOCK_INVITE_A_ID]: mockInviteA,
}
